
import { defineComponent } from 'vue'
import VerificationHeader from './VerificationHeader.vue'
import AccountManageHeader from '../components/AccountManageHeader.vue'

export default defineComponent({
  name: 'VerificationFail',
  components: {
    VerificationHeader,
    AccountManageHeader
  },
  setup(_, { emit }) {
    function closeModal() {
      emit('close')
    }

    return {
      closeModal
    }
  }
})
